export const RATES = [
  {
    lowerRange: 0,
    upperRange: 500000,
    variableResidential: 3.55,
    variableCommercial: 4.15,
    fixedResidential: 5.45,
    fixedCommercial: 6.25,
  },
  {
    lowerRange: 500001,
    upperRange: 1000000,
    variableResidential: 3.5,
    variableCommercial: 4.1,
    fixedResidential: 5.45,
    fixedCommercial: 6.25,
  },
  {
    lowerRange: 1000001,
    upperRange: 2500000,
    variableResidential: 3.45,
    variableCommercial: 4.05,
    fixedResidential: 5.45,
    fixedCommercial: 6.25,
  },
  {
    lowerRange: 2500001,
    upperRange: 5000000,
    variableResidential: 3.4,
    variableCommercial: 3.95,
    fixedResidential: 5.45,
    fixedCommercial: 6.25,
  },
  {
    lowerRange: 5000000,
    upperRange: 10000000,
    variableResidential: 3.25,
    variableCommercial: 3.85,
    fixedResidential: 5.3,
    fixedCommercial: 6.05,
  },
  {
    lowerRange: 10000001,
    upperRange: Number.MAX_VALUE,
    variableResidential: 3.05,
    variableCommercial: 3.65,
    fixedResidential: 5.15,
    fixedCommercial: 5.85,
  },
]

export const PRODUCTS_NEW_TO_BANK = {
  tracker: [
    {
      label: 'Residential 2Yr Tracker 70%',
      value: 'Residential 2Yr Tracker 70%',
      productName: 'Residential 2Yr Tracker 70%',
      productType: 'Cynergy Retail Mortgage',
      fundingType: 'variable',
      term: 24,
      marginRate: 2.54,
      rateToClient: 6.04,
      isProductFeePercantage: false,
      productFee: 995,
      adValorem: false,
      addedFeeToLoanWithin: 0.0995,
      addedFeeToLoanOutside: 0.0996,
      minMortgage: 250000,
      maxMortgage: 2000000,
      incomeEligability: 0,
      assetEligability: 0,
    },
    {
      label: 'Residential 2Yr Tracker 80%',
      value: 'Residential 2Yr Tracker 80%',
      productName: 'Residential 2Yr Tracker 80%',
      productType: 'Cynergy Retail Mortgage',
      fundingType: 'variable',
      term: 24,
      marginRate: 2.64,
      rateToClient: 6.14,
      isProductFeePercantage: false,
      productFee: 995,
      adValorem: false,
      addedFeeToLoanWithin: 0.0995,
      addedFeeToLoanOutside: 0.0996,
      minMortgage: 250000,
      maxMortgage: 2000000,
      incomeEligability: 0,
      assetEligability: 0,
    },
    {
      label: 'Wealth Mortgage 2Yr Tracker 70%',
      value: 'Wealth Mortgage 2Yr Tracker 70%',
      productName: 'Wealth Mortgage 2Yr Tracker 70%',
      productType: 'Cynergy Wealth Mortgage',
      fundingType: 'variable',
      term: 24,
      marginRate: 2.34,
      rateToClient: 5.84,
      isProductFeePercantage: true,
      productFee: 0.5,
      adValorem: true,
      addedFeeToLoanWithin: 0.5,
      addedFeeToLoanOutside: 0.5,
      minMortgage: 750000,
      maxMortgage: 10000000,
      incomeEligability: 300000,
      assetEligability: 3000000,
    },
    {
      label: 'Wealth Mortgage 2Yr Tracker 80%',
      value: 'Wealth Mortgage 2Yr Tracker 80%',
      productName: 'Wealth Mortgage 2Yr Tracker 80%',
      productType: 'Cynergy Wealth Mortgage',
      fundingType: 'variable',
      term: 24,
      marginRate: 2.44,
      rateToClient: 5.94,
      isProductFeePercantage: true,
      productFee: 0.5,
      adValorem: true,
      addedFeeToLoanWithin: 0.5,
      addedFeeToLoanOutside: 0.5,
      minMortgage: 750000,
      maxMortgage: 10000000,
      incomeEligability: 300000,
      assetEligability: 3000000,
    },
    {
      label: 'Wealth Structured Lending 2Yr Tracker 70%',
      value: 'Wealth Structured Lending 2Yr Tracker 70%',
      productName: 'Wealth Structured Lending 2Yr Tracker 70%',
      productType: 'Cynergy Wealth Mortgage',
      fundingType: 'variable',
      term: 24,
      marginRate: 2.49,
      rateToClient: 5.99,
      isProductFeePercantage: true,
      productFee: 1,
      adValorem: true,
      addedFeeToLoanWithin: 1,
      addedFeeToLoanOutside: 1,
      minMortgage: 750000,
      maxMortgage: 10000000,
      incomeEligability: 300000,
      assetEligability: 3000000,
    },
    {
      label: 'Wealth Structured Lending 2Yr Tracker 80%',
      value: 'Wealth Structured Lending 2Yr Tracker 80%',
      productName: 'Wealth Structured Lending 2Yr Tracker 80%',
      productType: 'Cynergy Wealth Mortgage',
      fundingType: 'variable',
      term: 24,
      marginRate: 2.59,
      rateToClient: 6.09,
      isProductFeePercantage: true,
      productFee: 1,
      adValorem: true,
      addedFeeToLoanWithin: 1,
      addedFeeToLoanOutside: 1,
      minMortgage: 750000,
      maxMortgage: 10000000,
      incomeEligability: 300000,
      assetEligability: 3000000,
    },
    {
      label: 'Self Build Mortgage 75%',
      value: 'Self Build Mortgage 75%',
      productName: 'Self Build Mortgage 75%',
      productType: 'Development Mortgage',
      fundingType: 'variable',
      term: 24,
      marginRate: 3.74,
      rateToClient: 7.24,
      isProductFeePercantage: true,
      productFee: 1,
      adValorem: true,
      addedFeeToLoanWithin: 1,
      addedFeeToLoanOutside: 1,
      minMortgage: 250000,
      maxMortgage: 2000000,
      incomeEligability: 0,
      assetEligability: 0,
    },
    {
      label: 'Residential 2Yr Fixed 70%',
      value: 'Residential 2Yr Fixed 70%',
      productName: 'Residential 2Yr Fixed 70%',
      productType: 'Cynergy Retail Mortgage',
      fundingType: 'fixed',
      term: 24,
      marginRate: 3.59,
      rateToClient: 3.59,
      isProductFeePercantage: false,
      productFee: 995,
      adValorem: false,
      addedFeeToLoanWithin: 0.0995,
      addedFeeToLoanOutside: 0.0996,
      minMortgage: 250000,
      maxMortgage: 2000000,
      incomeEligability: 0,
      assetEligability: 0,
    },
    {
      label: 'Residential 2Yr Fixed 80%',
      value: 'Residential 2Yr Fixed 80%',
      productName: 'Residential 2Yr Fixed 80%',
      productType: 'Cynergy Retail Mortgage',
      fundingType: 'fixed',
      term: 24,
      marginRate: 3.59,
      rateToClient: 3.59,
      isProductFeePercantage: false,
      productFee: 995,
      adValorem: false,
      addedFeeToLoanWithin: 0.0995,
      addedFeeToLoanOutside: 0.0996,
      minMortgage: 250000,
      maxMortgage: 2000000,
      incomeEligability: 0,
      assetEligability: 0,
    },
    {
      label: 'Residential 5Yr Fixed 70%',
      value: 'Residential 5Yr Fixed 70%',
      productName: 'Residential 5Yr Fixed 70%',
      productType: 'Cynergy Retail Mortgage',
      fundingType: 'fixed',
      term: 60,
      marginRate: 3.69,
      rateToClient: 3.69,
      isProductFeePercantage: false,
      productFee: 995,
      adValorem: false,
      addedFeeToLoanWithin: 0.0995,
      addedFeeToLoanOutside: 0.0996,
      minMortgage: 250000,
      maxMortgage: 2000000,
      incomeEligability: 0,
      assetEligability: 0,
    },
    {
      label: 'Residential 5Yr Fixed 80%',
      value: 'Residential 5Yr Fixed 80%',
      productName: 'Residential 5Yr Fixed 80%',
      productType: 'Cynergy Retail Mortgage',
      fundingType: 'fixed',
      term: 60,
      marginRate: 3.79,
      rateToClient: 3.79,
      isProductFeePercantage: false,
      productFee: 995,
      adValorem: false,
      addedFeeToLoanWithin: 0.0995,
      addedFeeToLoanOutside: 0.0996,
      minMortgage: 250000,
      maxMortgage: 2000000,
      incomeEligability: 0,
      assetEligability: 0,
    },
    {
      label: 'Wealth Mortgage 2Yr Fixed 70%',
      value: 'Wealth Mortgage 2Yr Fixed 70%',
      productName: 'Wealth Mortgage 2Yr Fixed 70%',
      productType: 'Cynergy Wealth Mortgage',
      fundingType: 'fixed',
      term: 24,
      marginRate: 3.49,
      rateToClient: 3.49,
      isProductFeePercantage: true,
      productFee: 0.5,
      adValorem: true,
      addedFeeToLoanWithin: 0.5,
      addedFeeToLoanOutside: 0.5,
      minMortgage: 750000,
      maxMortgage: 10000000,
      incomeEligability: 300000,
      assetEligability: 3000000,
    },
    {
      label: 'Wealth Mortgage 2Yr Fixed 80%',
      value: 'Wealth Mortgage 2Yr Fixed 80%',
      productName: 'Wealth Mortgage 2Yr Fixed 80%',
      productType: 'Cynergy Wealth Mortgage',
      fundingType: 'fixed',
      term: 24,
      marginRate: 3.59,
      rateToClient: 3.59,
      isProductFeePercantage: true,
      productFee: 0.5,
      adValorem: true,
      addedFeeToLoanWithin: 0.5,
      addedFeeToLoanOutside: 0.5,
      minMortgage: 750000,
      maxMortgage: 10000000,
      incomeEligability: 300000,
      assetEligability: 3000000,
    },
    {
      label: 'Wealth Mortgage 5Yr Fixed 70%',
      value: 'Wealth Mortgage 5Yr Fixed 70%',
      productName: 'Wealth Mortgage 5Yr Fixed 70%',
      productType: 'Cynergy Wealth Mortgage',
      fundingType: 'fixed',
      term: 60,
      marginRate: 3.54,
      rateToClient: 3.54,
      isProductFeePercantage: true,
      productFee: 0.5,
      adValorem: true,
      addedFeeToLoanWithin: 0.5,
      addedFeeToLoanOutside: 0.5,
      minMortgage: 750000,
      maxMortgage: 10000000,
      incomeEligability: 300000,
      assetEligability: 3000000,
    },
    {
      label: 'Wealth Mortgage 5Yr Fixed 80%',
      value: 'Wealth Mortgage 5Yr Fixed 80%',
      productName: 'Wealth Mortgage 5Yr Fixed 80%',
      productType: 'Cynergy Wealth Mortgage',
      fundingType: 'fixed',
      term: 60,
      marginRate: 3.64,
      rateToClient: 3.64,
      isProductFeePercantage: true,
      productFee: 0.5,
      adValorem: true,
      addedFeeToLoanWithin: 0.5,
      addedFeeToLoanOutside: 0.5,
      minMortgage: 750000,
      maxMortgage: 10000000,
      incomeEligability: 300000,
      assetEligability: 3000000,
    },
    {
      label: 'Wealth Structured Lending 2Yr Fixed 70%',
      value: 'Wealth Structured Lending 2Yr Fixed 70%',
      productName: 'Wealth Structured Lending 2Yr Fixed 70%',
      productType: 'Cynergy Wealth Mortgage',
      fundingType: 'fixed',
      term: 24,
      marginRate: 3.54,
      rateToClient: 3.54,
      isProductFeePercantage: true,
      productFee: 1,
      adValorem: true,
      addedFeeToLoanWithin: 1,
      addedFeeToLoanOutside: 1,
      minMortgage: 750000,
      maxMortgage: 10000000,
      incomeEligability: 300000,
      assetEligability: 3000000,
    },
    {
      label: 'Wealth Structured Lending 2Yr Fixed 80%',
      value: 'Wealth Structured Lending 2Yr Fixed 80%',
      productName: 'Wealth Structured Lending 2Yr Fixed 80%',
      productType: 'Cynergy Wealth Mortgage',
      fundingType: 'fixed',
      term: 24,
      marginRate: 3.64,
      rateToClient: 3.64,
      isProductFeePercantage: true,
      productFee: 1,
      adValorem: true,
      addedFeeToLoanWithin: 1,
      addedFeeToLoanOutside: 1,
      minMortgage: 750000,
      maxMortgage: 10000000,
      incomeEligability: 300000,
      assetEligability: 3000000,
    },
    {
      label: 'Wealth Structured Lending 5Yr Fixed 70%',
      value: 'Wealth Structured Lending 5Yr Fixed 70%',
      productName: 'Wealth Structured Lending 5Yr Fixed 70%',
      productType: 'Cynergy Wealth Mortgage',
      fundingType: 'fixed',
      term: 24,
      marginRate: 3.64,
      rateToClient: 3.64,
      isProductFeePercantage: true,
      productFee: 1,
      adValorem: true,
      addedFeeToLoanWithin: 1,
      addedFeeToLoanOutside: 1,
      minMortgage: 750000,
      maxMortgage: 10000000,
      incomeEligability: 300000,
      assetEligability: 3000000,
    },
    {
      label: 'Wealth Structured Lending 5Yr Fixed 80%',
      value: 'Wealth Structured Lending 5Yr Fixed 80%',
      productName: 'Wealth Structured Lending 5Yr Fixed 80%',
      productType: 'Cynergy Wealth Mortgage',
      fundingType: 'fixed',
      term: 24,
      marginRate: 3.74,
      rateToClient: 3.74,
      isProductFeePercantage: true,
      productFee: 1,
      adValorem: true,
      addedFeeToLoanWithin: 1,
      addedFeeToLoanOutside: 1,
      minMortgage: 750000,
      maxMortgage: 10000000,
      incomeEligability: 300000,
      assetEligability: 3000000,
    },
  ],
}

export const PRODUCTS_RETENTION = [{}, {}]

export const appUrl = (process.env.URL ?? process.env.NEXT_PUBLIC_DOMAIN ?? '')
  // The netlify domain points to non-www, but there is no redirect in place
  .replace('https://cynergybank.co.uk', 'https://www.cynergybank.co.uk')

// @ts-ignore
export const CONTENTFUL_ENVIRONMENT: 'Development' | 'Staging' | 'master' =
  process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT!
